import { render, staticRenderFns } from "./PaymentPageHeader.vue?vue&type=template&id=68095d10&"
import script from "./PaymentPageHeader.vue?vue&type=script&lang=js&"
export * from "./PaymentPageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports